var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { noop } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { FormsAddTimeService } from '../../forms/add-time.service';
import { ModalSimpleComponent } from '../../modal-simple/modal-simple.component';
import { ModalSimpleService } from '../../modal-simple/modal-simple.service';
import { MomentService } from '../moment/moment.service';
import { SHORTCUT_MISC, ShortcutHandlerService } from '../shortcut-handler/shortcut-handler.service';
import { TimerService } from './timer.service';
var TimerComponent = (function () {
    function TimerComponent(timerService, authService, formsAddTimeService, shortcutHandlerService, momentService, modalSimpleService) {
        this.timerService = timerService;
        this.authService = authService;
        this.formsAddTimeService = formsAddTimeService;
        this.shortcutHandlerService = shortcutHandlerService;
        this.momentService = momentService;
        this.modalSimpleService = modalSimpleService;
        this.showCollapsedDrawer = false;
        this.showTimerModal = false;
    }
    TimerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.shortcutHandlerService.register({
            name: SHORTCUT_MISC.TOGGLE_TIMER,
            shortcut: SHORTCUT_MISC.TOGGLE_TIMER,
            callback: function () {
                _this.timerService.timer.toggle();
            },
            context: this,
        });
    };
    TimerComponent.prototype.openModal = function () {
        this.stopTimer();
        this.showTimerModal = true;
    };
    TimerComponent.prototype.stopTimer = function () {
        if (this.timerService.timer.isRunning) {
            this.timerService.timer.toggle();
        }
        var now = this.momentService.moment();
        var nowStr = now.format('YYYY-MM-DD');
        this.paramsTimerModal = {
            startDate: this.timerService.timer.startDate.format('YYYY-MM-DD'),
            endDate: nowStr,
        };
    };
    TimerComponent.prototype.cancel = function () {
        this.showTimerModal = false;
    };
    TimerComponent.prototype.reset = function () {
        var _this = this;
        this.modalSimpleService
            .open(ModalSimpleComponent, {
            title: 'modal_title_cancel_timer',
            contentI18n: 'swal_are_you_sure',
            ok: {
                i18n: 'cancel_timer',
                class: 'btn-danger',
            },
        })
            .subscribe(function (closed) {
            if (closed.result) {
                _this.timerService.timer.stop();
            }
        }, noop);
    };
    TimerComponent.prototype.assign = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.formsAddTimeService.submit(item.time, item.task)];
                    case 1:
                        if (_a.sent()) {
                            this.cancel();
                        }
                        return [2];
                }
            });
        });
    };
    return TimerComponent;
}());
export { TimerComponent };
